import React, { ReactElement } from 'react'
import { connect } from 'react-redux'
import ApiTokenList from './ApiTokenList'
import { IAccessScope } from 'reducers/Reducers.interfaces'
import NoPermissionsPage from 'shared/components/no-permissions-page'
import ClientAuthCertList from './ClientAuthCertList'
import styles from './AccessCredentials.module.scss'
import { Translate } from 'react-localize-redux'

const AccessCredentials = ({ user, profile }): ReactElement => {

  if (user?.id === profile?.id) {
    return (
      <>
      <h1 className={styles.heading}><Translate id='notifications.users.details.credentials'/></h1>
      <p className={styles.description}><Translate id='notifications.users.details.credentialsDescription'/></p>
      <div className={styles.content}>
      <ApiTokenList user={user} profile={profile} />
      <ClientAuthCertList user={user} profile={profile} />
      </div>
      </>
    )
  } else {
    return (<NoPermissionsPage />)
  }

}
export default connect(null, {})(AccessCredentials);
